export default "/images/16 Step3TakeAction-Consultant-To monitor progress-01.png?537911a5f612a84f4df6df5961fd578f";